<template>
    <transition
        :name="getTransitionName"
    >
        <Modal
            v-if="shouldShowModal"
            :code="modal.code"
            :group="modal.group"
            :title="title"
            :containerClass="modal.containerClass"
            :modalComponent="modal.component"
            :header="modal.header"
            :setModal="setModal"
            :closeModal="onClose"
            :isIndependent="modal.isIndependent"
            :isClosable="modal.isClosable"
            :key="modal.uuid"
            :isLoading="isLoading"
            @close="onClose"
        />
    </transition>
</template>

<script>
    import {
        mapGetters,
        mapActions,
    } from 'vuex';

    import { logger } from '@app/logger';
    import { errorGuard } from '@utils/ErrorGuard';

    import Modal from './Modal.vue';
    import { isModalShownOnCurrentRoute } from '@store/modules/ui/shared/modal/helpers';

    export default {
        name: 'ModalContainer',
        data() {
            return {
                isLoading: false,
            };
        },
        computed: {
            ...mapGetters('ui/modal', [
                'modal',
                'modalData',
            ]),
            getTransitionName() {
                return this.modal?.shouldShowTransition ? this.modal?.transition?.name : 'no-transition';
            },
            title() {
                return this.modalData.title ?? this.modal.title;
            },
            shouldShowModal() {
                return !!this.modal && isModalShownOnCurrentRoute(this.$route, this.modal);
            },
        },
        methods: {
            ...mapActions('ui/modal', [
                'setModal',
                'closeModal',
            ]),
            ...mapActions('ui/user/messages', [
                'respondAndShowNextMessage',
            ]),
            async onClose(closeOptions) {
                const afterClose = this.modal.afterClose;

                if (this.modalData.isModalDismissable) {
                    await this.dismissModal(this.modalData.actions[0].id);
                } else {
                    this.closeModal({ group: closeOptions?.group });
                }

                if (afterClose) {
                    afterClose(this.$store.dispatch);
                }
            },
            logUnregisteredModal() {
                logger.error(`No such modal code: ${this.modal.code}! Register it with registerModals`);
            },
            async dismissModal(actionId) {
                if (this.isLoading) {
                    return;
                }
                this.isLoading = true;
                /*
                    Since this modal is closed when showing the next one (for the error
                    or the next message), there is no need to close it explicitly.
                */
                await errorGuard(() => this.respondAndShowNextMessage({
                    actionId,
                    shouldShowNextMessage: false,
                }));
                this.isLoading = false;
            },
        },
        components: {
            Modal,
        },
    };
</script>
